import { createContext, useContext } from "react";
import { FeatureFlag } from "./activeFlags";

export const FeatureFlagContext = createContext({
  isFeatureActive: FeatureFlag.isFeatureActive,
});

export const useFeatureFlags = () =>
  useContext(FeatureFlagContext).isFeatureActive;

export const useFeatureFlag = (flagName) => useFeatureFlags()(flagName);
